import React, { useState } from "react";

export default function TextForm(props) {
  document.title = "TextUtils - Home";
  const handleUpClick = () => {
    //uppercase
    let newText = text.toUpperCase();
    setText(newText);
    props.showAlert("Converted to UpperCase","success");
  };
  const handleLoClick = () => {
    // lowercase
    let newText = text.toLowerCase();
    setText(newText);
    props.showAlert("Converted to LowerCase","success");
  };
  const handleClearClick = () => {
    // cleartext
    let newText = "";
    setText(newText);
    props.showAlert("Cleared all text","danger");
  };
  const handleRwClick = () => {
    // removing a word
    let newtext = text.toLowerCase();
    newtext = newtext.replaceAll("."," . ");
    newtext = newtext.trim().split(" ");
    let input = prompt("Enter the word you want to remove : ");
    if (input !== null && input!=="") {
      props.showAlert(`Removed the word "${input}"`,"danger");
      input = input.toLowerCase();
      while (newtext.includes(input)) {
        let index = newtext.indexOf(input);
        newtext.splice(index, 1);
      }
      newtext = newtext.join(" ");
      newtext = newtext.replace(newtext.charAt(0),newtext.charAt(0).toUpperCase());
      setText(newtext);
    }
  };
  const handleCopyClick = () => {
    // copy text
    var copyText = document.getElementById("mybox");
    copyText.select();
    navigator.clipboard.writeText(copyText.value);
    props.showAlert("Copied the text","success");
  };
  const handleOnChange = (event) => {
    setText(event.target.value);
  };
  const [text, setText] = useState("");
  function words() {
    // this function counts the number of words
    let words = text.trim().split(" ").length;
    if (words === 1 && text.split(" ")[0] === "") {
      words = 0;
      return words;
    } else {
      return words;
    }
  }
  return (
    <>
      <div className="container my-5" style={{color:props.mode==="dark"?"white":"black"}}>
        <h2>{props.heading}</h2>
        <div className="mb-3">
          <textarea
            className="form-control"
            id="mybox"
            rows="8"
            value={text}
            onChange={handleOnChange}
            placeholder="Enter your text here"
            style={{backgroundColor:props.mode==="dark"?"#333333":"white",color:props.mode==="dark"?"white":"black"}}
          ></textarea>
        </div>
        <button  disabled={text.length===0}  className="btn btn-primary m-2" onClick={handleUpClick}>
          Convert to UpperCase
        </button>
        <button  disabled={text.length===0}  className="btn btn-primary m-2" onClick={handleLoClick}>
          Convert to LowerCase
        </button>
        <button  disabled={text.length===0}  className="btn btn-primary m-2" onClick={handleCopyClick}>
          Copy Text
        </button>
        <button  disabled={text.length===0}  className="btn btn-primary m-2" onClick={handleRwClick}>
          Remove a word
        </button>
        <button  disabled={text.length===0}  className="btn btn-danger m-2" onClick={handleClearClick}>
          Clear Text
        </button>
      </div>
      <div className="container my-2" style={{color:props.mode==="dark"?"white":"black"}}>
        <h3># Your Text Summary</h3>
        <p>
          <b>👉 {words()}</b> words and <b>{text.length} </b>characters.
        </p>
        <p>
          <b>{(0.008 * text.split(" ").length - 0.008).toFixed(3)}</b> Minutes read.
        </p>
        <h3># Preview</h3>
        <p>{text.length>0?text:"Enter something in the textbox to preview here."}</p>
      </div>
    </>
  );
}
